import React from "react";
import { Link } from "react-router-dom";
import { ChevronLeft } from "lucide-react";

/**
 * Minimal scaffold legal pages (Privacy Policy / Terms of Service / DPA).
 * Deliberately generic with `{{TODO: …}}` markers so that the customer's
 * legal team can fill in company-specific language before production launch.
 */
export default function LegalPage({ title, subtitle, lastUpdated, children, testid }) {
    return (
        <div className="min-h-screen bg-[#fafafa]" data-testid={testid}>
            <nav className="border-b border-hair bg-white sticky top-0 z-40">
                <div className="max-w-[1100px] mx-auto px-6 md:px-12 h-16 flex items-center justify-between">
                    <Link
                        to="/"
                        className="flex items-center gap-2"
                        data-testid="legal-nav-brand"
                    >
                        <img
                            src="/audri-logo.png"
                            alt="AudRI"
                            className="w-9 h-9 rounded-sm"
                        />
                        <div>
                            <div className="heading font-bold leading-none tracking-tight">
                                audri
                            </div>
                            <div className="overline text-[9px] mt-[2px]">
                                Audit Realtime Intelligence
                            </div>
                        </div>
                    </Link>
                    <Link
                        to="/"
                        className="inline-flex items-center gap-1 text-sm text-neutral-600 hover:text-[#C2410C]"
                        data-testid="legal-back-home"
                    >
                        <ChevronLeft size={14} /> Back home
                    </Link>
                </div>
            </nav>

            <article className="max-w-[900px] mx-auto px-6 md:px-12 py-16 md:py-24">
                <div className="overline mb-4">Legal · AudRI</div>
                <h1 className="heading text-4xl md:text-5xl tracking-tighter font-medium">
                    {title}
                </h1>
                {subtitle && (
                    <p className="mt-4 text-neutral-600 leading-relaxed">{subtitle}</p>
                )}
                <div className="mono text-[11px] text-neutral-500 tracking-widest uppercase mt-6">
                    Last updated · {lastUpdated}
                </div>

                <div className="mt-10 prose prose-neutral max-w-none text-[15px] leading-relaxed [&_h2]:heading [&_h2]:text-2xl [&_h2]:font-medium [&_h2]:tracking-tight [&_h2]:mt-12 [&_h2]:mb-3 [&_h3]:heading [&_h3]:text-lg [&_h3]:font-medium [&_h3]:mt-8 [&_h3]:mb-2 [&_p]:text-neutral-700 [&_p]:mt-3 [&_ul]:list-disc [&_ul]:pl-6 [&_ul]:mt-3 [&_ul]:text-neutral-700 [&_li]:mt-1">
                    {children}
                </div>

                <div className="mt-16 border-t border-hair pt-6 text-xs text-neutral-500">
                    Questions? Email{" "}
                    <a
                        href="mailto:legal@audri.app"
                        className="text-[#C2410C] hover:underline"
                    >
                        legal@audri.app
                    </a>
                    .
                </div>
            </article>
        </div>
    );
}
